import { React, useState, useEffect, useRef } from "react";
import { Modal, Button } from "react-bootstrap";
import { Input, FormFeedback } from "reactstrap";
import { Select } from "react-select-virtualized";
import helper from "../../Helper/Helper";
import { validateAll } from "indicative/validator";
import { useDispatch, useSelector } from "react-redux";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import AnalogTimePicker from "../../Components/AnalogTimePicker";
import { format } from "date-fns";
import AxiosApi from "../../Helper/axios.api";
import { toast } from "react-toastify";
import moment from "moment";
import { updateTotalCoins } from "../../Action/Auth.action";
import { Link } from "react-router-dom";

export default function AddSessionForm(props) {

  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [disablebutton, setDisablebutton] = useState(false);
  const [errormessage, setErrormessage] = useState("");
  const [minUpdateEventDate, setMinUpdateEventDate] = useState(moment.utc(new Date()).add(1, 'd').format());
  const [cost, setCost] = useState("");
  const videoRef = useRef(null);
  const auth = useSelector((user) => user.auth);

  const getNowOffset = (minutes) => {
    const now = new Date();
    now.setMinutes(now.getMinutes() + minutes);
    now.setSeconds(0);
    now.setMilliseconds(0);
    return now;
  }

  const defaultStartDate = (auth.userDeatils.is_admin || auth.userDeatils.is_staff) ? getNowOffset(-1) : getNowOffset(5);

  const [state, setState] = useState({
    sessionName: "",
    timeStart: format(defaultStartDate, "yyyy-MM-dd HH:mm"),
    timeEnd: "",
    utctimeStart: moment.utc(defaultStartDate).format(),
    utctimeEnd: "",
    zoomLink: "https://zoom.us/j/700700700700",
    template_id: props.templeteid,
    reservation_id: props.reservation_id,
    duration: "",
    errors: {},
  });
  const { sessionName, timeStart, timeEnd, template_id, reservation_id, utctimeStart, utctimeEnd, duration, zoomLink, errors } = state;
  const [startDate, setStartDate] = useState(defaultStartDate);
  const [initialDuration, setInitialDuration] = useState(false);
  const [maintenanceIntervals, setMaintenanceIntervals] = useState([]);

  const isVoiceMorphingEnabled = () => {
    if (props.formType === "virtualizationForm") {
      return props.animationData?.enable_morphing;
    } else if (props.formType === "sessionsForm") {
      return props.options?.find(opt => opt.id === template_id)?.enable_morphing;
    }
    return false;
  };

  const getTotalCost = (minute, enableVoiceMorphing = false) => {
    // 5 credits per 30mins, double cost if voice morphing is enabled
    const baseCost = minute * 5 / 30;
    return enableVoiceMorphing ? baseCost * 2 : baseCost;
  }

  const onChangeValue = (e) => {
    let value = e.target.value;
    if (e.target.name === 'duration') {
      let duration_array = e.target.value.split(" ");
      if (duration_array[0] > 0) {
        let cost_time = getTotalCost(duration_array[0], isVoiceMorphingEnabled());
        setCost(cost_time)
        if(cost_time > auth.total_coin){
          setDisablebutton(true)
        }else{
          setDisablebutton(false)
        }
      } else {
        setCost("")
      }
    }
    setState({
      ...state,
      [e.target.name]: value,
    });
    setErrormessage("");
  };

  const onChange = (date, type) => {
    if (type === "startDate") {
      setStartDate(date);
      let sDate = format(date, "yyyy-MM-dd HH:mm");
      setState({
        ...state,
        timeStart: sDate,
        utctimeStart: moment.utc(date).format()
      });
    } else {
      if (type === "endDate") {
        let eDate = format(date, "yyyy-MM-dd HH:mm");
        setState({
          ...state,
          timeEnd: eDate,
          utctimeEnd: moment.utc(date).format()
        });
      }
    }
  };

  const fetchMaintenance = async () => {
    try {
      const res = await AxiosApi.withToken(
        auth.accessToken,
        'maintenance/status',
        'get'
      );
      if (!res || res.status === false) return;
      const d = res.data || {};
      let items = d.ongoing || [];
      items = items.concat(d.upcoming);
      const intervals = items
        .map((p) => ({ start: new Date(p.start || p.start_time), end: new Date(p.end || p.end_time), note: p.note || p.message || '' }))
        .filter((iv) => iv.start && iv.end && !isNaN(iv.start) && !isNaN(iv.end));
      setMaintenanceIntervals(intervals);
    } catch (e) {
      console.error(e);
    }
  };

  const overlapsMaintenance = (startISO, endISO) => {
    if (!maintenanceIntervals.length) return false;
    const startMs = +new Date(startISO);
    const endMs = +new Date(endISO);
    if (isNaN(startMs) || isNaN(endMs)) return false;
    return maintenanceIntervals.some(({ start, end }) => {
      const s = +start, e = +end;
      return !isNaN(s) && !isNaN(e) && startMs < e && endMs > s;
    });
  };

  const selectionOverlapsMaintenance = (() => {
    if (!duration || !utctimeStart || auth.userDeatils.is_admin) return false;
    const arr = duration.split(" ");
    if (!arr[0] || !arr[1]) return false;
    const end_time = moment.utc(utctimeStart).add(arr[0], arr[1]).format();
    return overlapsMaintenance(utctimeStart, end_time);
  })();

  const resetForm = () => {
    const newDefaultDate = getNowOffset(5);
    setStartDate(newDefaultDate);
    setCost("")
    setState({
      sessionName: "",
      timeStart: format(newDefaultDate, "yyyy-MM-dd HH:mm"),
      timeEnd: "",
      utctimeStart: moment.utc(newDefaultDate).format(),
      utctimeEnd: "",
      zoomLink: "https://zoom.us/j/700700700700",
      reservation_id: "",
      duration: "",
      errors: {}
    });

    if (props.formType === "sessionsForm") {
      props.setAnimationThumb("")
      props.setTemplate_name("")
    }
    props.settempleteid("")
    props.setReservation_id("")
    props.setModal(false);

  };

  const submitSessionForm = (e) => {
    e.preventDefault();
    const rules = {
      sessionName: "required",
      timeStart: "required",
      duration: "required",
      zoomLink: "url",
      template_id: "required",

    };

    const message = {
      "sessionName.required": "Session Name is Required.",
      "template_id.required": "Virtualization is Required.",
      "timeStart.required": "Time Start is Required.",
      "duration.required": "Duration is Required.",
      "zoomLink.required": "DeepTherapy Link is Required.",
      "zoomLink.url": "Enter a valid URL.",
    };

    validateAll(state, rules, message)
      .then(async () => {
        setLoading(true);
        setErrormessage("")
        let data = {};
        let duration_array = duration.split(" ");

        let end_time = moment.utc(utctimeStart).add(duration_array[0], duration_array[1]).format();
        if (!auth.userDeatils.is_admin && overlapsMaintenance(utctimeStart, end_time)) {
          setLoading(false);
          setErrormessage("Selected time overlaps with scheduled maintenance. Please pick another time.");
          return;
        }
        data.user_id = auth.userDeatils.user_id;
        data.template_id = template_id;
        data.name = sessionName;
        data.time_start = utctimeStart;
        data.time_end = end_time;
        data.zoom_link = zoomLink;
        data.duration = duration_array[0];
        let url = "reservations/create";

        if (reservation_id) {
          data.reservation_id = reservation_id;
          url = "reservations/edit"
        }

        // data.time_zone = helper.userTimezone;

        AxiosApi.withToken(
          auth.accessToken,
          url,
          "post",
          data
        )
          .then((res) => {
            if (res.status) {
              toast.success(res.message, {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
              });
              resetForm();
              dispatch(updateTotalCoins(res.data))
              props.setIsUpdate(!props.isUpdate);
            } else {
              setErrormessage(res.message)
            }
            setLoading(false);
          })
          .catch((errors_res) => {
            setLoading(false);
          });
      })
      .catch((errors) => {
        console.log(errors)
        setLoading(false);
        const formattedErrors = {};
        errors.forEach(
          (error) => (formattedErrors[error.field] = error.message)
        );
        setState({
          ...state,
          errors: formattedErrors,
        });
      });
  };

  const getreservation = async (reservation_id) => {
    await AxiosApi.withToken(auth.accessToken, "reservations/" + reservation_id + "/details", "get", {})
      .then(async (res) => {
        var diff = Math.abs(new Date(res.data.time_start) - new Date(res.data.time_end));
        var minutes = Math.floor((diff / 1000) / 60);

        if (res.status) {
          setState({
            ...state,
            sessionName: res.data.name,
            duration: `${minutes} minutes`,
            template_id: res.data.template_id,
            timeStart: moment(res.data.time_start).local().toDate(),
            utctimeStart: moment.utc(res.data.time_start).format(),
            zoomLink: res.data.zoom_link,
            reservation_id: res.data.id
          });
          setInitialDuration(minutes);
          // Check if the template has voice morphing enabled
          const templateHasVoiceMorphing = props.options?.find(opt => opt.id === res.data.template_id)?.enable_morphing || false;
          setCost(getTotalCost(minutes, templateHasVoiceMorphing))
          setStartDate(moment(res.data.time_start).local().toDate());
        } else {
          toast.error(res.message, {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
        setLoading(false);
      })
      .catch((errors_res) => {
        setLoading(false);
      });
  }
  useEffect(() => {

    if (videoRef.current)
      videoRef.current.load()

    setState({
      ...state,
      template_id: props.templeteid,
    });

  }, [props.animationThumb]);
  useEffect(() => {
    fetchMaintenance();
  }, []);
  useEffect(() => {
    setState({
      ...state,
      template_id: props.templeteid,
    });

    // Recalculate cost when template changes (voice morphing settings may be different)
    if (duration) {
      let duration_array = duration.split(" ");
      if (duration_array[0] > 0) {
        let cost_time = getTotalCost(duration_array[0], isVoiceMorphingEnabled());
        setCost(cost_time);
        if(cost_time > auth.total_coin){
          setDisablebutton(true);
        } else {
          setDisablebutton(false);
        }
      }
    }

  }, [props.templeteid]);
  useEffect(() => {
    (async () => {

      if (props.reservation_id && props.reservation_id != '') {
        await getreservation(props.reservation_id);
      }

    })()

    return function () {
    };
  }, [props.reservation_id])
  const delete_reservations = async (reservation_id) => {
    setLoading(true);
    let data_params = {}
    data_params.user_id = auth.userDeatils.user_id;
    data_params.reservation_id = reservation_id;
    setErrormessage("")
    await AxiosApi.withToken(auth.accessToken, "reservations/delete", "post", data_params)
      .then(async (res) => {
        if (res.status) {

          toast.success(res.message, {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
          resetForm();
          props.setIsUpdate(!props.isUpdate);
        } else {
          setErrormessage(res.message)
          // toast.error(res.message, {
          //   position: "top-center",
          //   autoClose: 5000,
          //   hideProgressBar: false,
          //   closeOnClick: true,
          //   pauseOnHover: true,
          //   draggable: true,
          //   progress: undefined,
          // });
        }

        setLoading(false);
      })
      .catch((errors_res) => {
        setLoading(false);
      });
  }

  const render_footer_for_update_schedule = () => {
    if (minUpdateEventDate < utctimeStart) {
      return (
        <>
          <div className="col-md-3 d-flex align-items-center">
            <div className="footer-text">
              <div className="col-md-12 d-flex justify-content-between" style={{lineHeight: '18px'}}>
                <span style={{ fontWeight: '700', fontSize: '16px' }}>Balance:</span>
                <span className="text-muted" style={{ paddingLeft: '15px' }} >
                  <strong style={{ color: "#EA3F95" }}>{auth.total_coin ? auth.total_coin : ''}</strong> credits
                </span>
              </div>
              {
                cost > 0 && `${initialDuration} minutes` != duration ? (
                  <div className="col-md-12 d-flex justify-content-between"  style={{lineHeight: '18px'}}>
                    <span style={{ fontWeight: '700', fontSize: '16px' }}>
                      {getTotalCost(initialDuration, isVoiceMorphingEnabled()) - cost < 0 ? 'Cost': 'Refund'}:
                    </span>
                    <span className="text-muted" style={{ paddingLeft: '15px' }} >
                      <strong style={{ color: "#EA3F95" }}>{Math.abs(getTotalCost(initialDuration, isVoiceMorphingEnabled()) - cost)}</strong> credits
                    </span>
                  </div>
                ) : ""
              }
            </div>
          </div>

          <div className="col-md-3">
            <Button
              variant="contained"
              className="btn-primary float-right"
              style={{ float: 'right' }}
              disabled={disablebutton || selectionOverlapsMaintenance}
              onClick={(e) => submitSessionForm(e)}
            >
              Update Session
            </Button>
          </div>
        </>
      )
    }
    return ""
  }

  const render_footer_for_create_new_schedule = () => {
    return (
      <>
        <div className="col-md-3 d-flex align-items-center">
          <div className="footer-text">
            <div className="col-md-12 d-flex justify-content-between" style={{lineHeight: '18px'}}>
              <span style={{ fontWeight: '700', fontSize: '16px' }}>Balance:</span>
              <span className="text-muted" style={{ paddingLeft: '15px' }} >
                <strong style={{ color: "#EA3F95" }}>{auth.total_coin ? auth.total_coin : ''}</strong> credits
              </span>
            </div>
            {
              cost > 0 ? (
                <div className="col-md-12 d-flex justify-content-between"  style={{lineHeight: '18px'}}>
                  <span style={{ fontWeight: '700', fontSize: '16px' }}>
                    Cost:
                  </span>
                  <span className="text-muted" style={{ paddingLeft: '15px' }} >
                    <strong style={{ color: "#EA3F95" }}>{cost}</strong> credits
                  </span>
                </div>
              ) : ""
            }
          </div>
        </div>

        <div className="col-md-3">
          <Button
            variant="contained"
            className="btn-primary float-right"
            style={{ float: 'right' }}
            disabled={disablebutton || selectionOverlapsMaintenance}
            onClick={(e) => submitSessionForm(e)}
          >
            Create Session
          </Button>
        </div>
      </>
    )
  }

  return (
    <>
      <Modal
        size="lg"
        show={props.modal}
        onHide={() => resetForm()}
        aria-labelledby="example-modal-sizes-title-lg"
        className="create-animation-modal advanced-modal"
        animation={true}
        centered
        style={{ zIndex: "1040" }}
      >
        <Modal.Header>
          <Modal.Title id="example-modal-sizes-title-lg">
            Schedule DeepTherapy Session
          </Modal.Title>
          <button
            type="button"
            className="modalOpenBtn btn bg-gradient-success pull-right"
            data-bs-toggle="modal"
            onClick={() => resetForm()}
          >
            <i
              style={{ fontSize: 20 }}
              className="fa fa-times"
              aria-hidden="true"
            ></i>
          </button>
        </Modal.Header>
        <Modal.Body>
          <form className="session-form profile-form">
            <div id={loading ? "pageLoader" : ""} />
            <div className="session-form-block profile-form-block">
              <div className="row">
                <div className="col-md-4">
                  {props.formType === "virtualizationForm" ? (
                    <>
                      <label className="mb-2 d-flex align-items-center" style={{
                        fontSize: '14px',
                        fontWeight: '600',
                        color: '#495057'
                      }}>
                        <i className="fa fa-play-circle me-2" style={{color: '#65badbff', fontSize: '12px'}}></i>
                        Animation
                      </label>

                      <div className="card" style={{
                        padding: '0',
                        border: '1px solid #ced4da',
                        borderRadius: '8px',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                        overflow: 'hidden',
                        width: '100%',
                        margin: '0 0'
                      }}>
                          {props.animationData.video ? (
                            <video
                              controls
                              style={{
                                width: '100%',
                                height: 'auto',
                                borderRadius: '8px 8px 0 0',
                                display: 'block'
                              }}
                              ref={videoRef}
                            >
                              <source src={`${helper.ApiBaseUrl}${props.animationData.video}`} />
                            </video>
                          ) : (
                            <img
                                style={{
                                  width: '100%',
                                  height: 'auto',
                                  borderRadius: '8px 8px 0 0',
                                  display: 'block'
                                }}
                                src={`${helper.ApiBaseUrl}${props.animationData.thumb}`}
                            />
                          )}
                        <div className="card-body" style={{ padding: '12px 16px' }}>
                          <h5 className="card-title mb-0" style={{
                            fontWeight: '600',
                            fontSize: '14px',
                            color: '#495057',
                            lineHeight: '1.4'
                          }} title={props.animationData.name}>
                            {props.animationData.name}
                          </h5>
                        </div>
                      </div>
                    </>
                  ) : (
                    <>
                      <label className="mb-2 d-flex align-items-center" style={{
                        fontSize: '14px',
                        fontWeight: '600',
                        color: '#495057'
                      }}>
                        <i className="fa fa-play-circle me-2" style={{color: '#65badbff', fontSize: '12px'}}></i>
                        Animation
                      </label>
                      <div style={{
                        borderRadius: '4px',
                        border: errors.template_id ? '2px solid #dc3545' : '1px solid #ced4da',
                        overflow: 'hidden',
                        boxShadow: errors.template_id ? '0 0 0 0.1rem rgba(220, 53, 69, 0.2)' : 'inset 0 1px 2px rgba(0, 0, 0, 0.1)',
                        transition: 'all 0.2s ease-in-out'
                      }}>
                        <Select
                          defaultValue={{ video:props.animationVideo, thumb: props.animationThumb, value: template_id, label: props.template_name, id: template_id }}
                          options={props.options}
                          onChange={props.onSelectChange}
                          placeholder="Select an animation..."
                          menuPortalTarget={document.body}
                          menuPosition={'fixed'}
                          className={
                            errors.template_id
                              ? "is-invalid"
                              : ""
                          }
                          styles={{
                            control: (provided, state) => ({
                              ...provided,
                              border: 'none',
                              boxShadow: 'none',
                              fontSize: '14px',
                              fontWeight: '400',
                              minHeight: '40px',
                              backgroundColor: '#ffffff',
                              cursor: 'pointer',
                              '&:hover': {
                                borderColor: 'transparent'
                              }
                            }),
                            placeholder: (provided) => ({
                              ...provided,
                              color: '#6c757d',
                              fontSize: '14px'
                            }),
                            singleValue: (provided) => ({
                              ...provided,
                              color: '#495057',
                              fontSize: '14px'
                            }),
                            dropdownIndicator: (provided) => ({
                              ...provided,
                              color: '#65badbff',
                              '&:hover': {
                                color: '#007bff'
                              }
                            }),
                            menu: (provided) => ({
                              ...provided,
                              borderRadius: '4px',
                              boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
                              border: '1px solid #e9ecef',
                              zIndex: 9999
                            }),
                            menuPortal: (provided) => ({
                              ...provided,
                              zIndex: 9999
                            }),
                            option: (provided, state) => ({
                              ...provided,
                              fontSize: '14px',
                              padding: '10px 12px',
                              backgroundColor: state.isSelected ? '#007bff' : state.isFocused ? '#f8f9fa' : 'white',
                              color: state.isSelected ? 'white' : '#495057',
                              '&:hover': {
                                backgroundColor: state.isSelected ? '#007bff' : '#e9ecef'
                              }
                            })
                          }}
                        />
                      </div>
                      {errors.template_id ? (
                        <div className="invalid-error">
                          {errors.template_id}
                        </div>
                      ) : (
                        ""
                      )}
                      {props.animationVideo ? (
                        <div className="mt-3" style={{
                          borderRadius: '8px',
                          overflow: 'hidden',
                          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                          border: '1px solid #ced4da',
                          width: '100%'
                        }}>
                          <video
                            controls
                            style={{
                              width: '100%',
                              height: 'auto',
                              display: 'block'
                            }}
                            ref={videoRef}
                          >
                            <source src={`${helper.ApiBaseUrl}${props.animationVideo}`} />
                          </video>
                        </div>
                        ) : props.animationThumb && (
                          <div className="mt-3" style={{
                            borderRadius: '8px',
                            overflow: 'hidden',
                            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                            border: '1px solid #ced4da',
                            width: '100%'
                          }}>
                            <img
                              src={`${helper.ApiBaseUrl}${props.animationThumb}`}
                              style={{
                                width: '100%',
                                height: 'auto',
                                display: 'block'
                              }}
                            />
                          </div>
                        )
                      }
                    </>
                  )}
                </div>
                <div className="col-md-8">
                  <div className="row">
                    <div className="col-md-12">
                      <label className="mb-2 d-flex align-items-center" style={{
                        fontSize: '14px',
                        fontWeight: '600',
                        color: '#495057'
                      }}>
                        <i className="fa fa-calendar me-2" style={{color: '#65badbff', fontSize: '12px'}}></i>
                        Session Name
                      </label>
                      <Input
                        type="text"
                        className="form-control mb-2"
                        placeholder="Enter session name"
                        defaultValue={sessionName}
                        id="sessionName"
                        name="sessionName"
                        onChange={(e) => onChangeValue(e)}
                        invalid={errors.sessionName ? true : false}
                        style={{
                          borderRadius: '4px',
                          border: errors.sessionName ? '2px solid #dc3545' : '1px solid #ced4da',
                          backgroundColor: '#ffffff',
                          padding: '8px 12px',
                          fontSize: '14px',
                          fontWeight: '400',
                          transition: 'all 0.2s ease-in-out',
                          boxShadow: errors.sessionName ? '0 0 0 0.1rem rgba(220, 53, 69, 0.2)' : 'inset 0 1px 2px rgba(0, 0, 0, 0.1)'
                        }}
                        onFocus={(e) => {
                          if (!errors.sessionName) {
                            e.target.style.borderColor = '#007bff';
                            e.target.style.boxShadow = 'inset 0 1px 2px rgba(0, 0, 0, 0.1), 0 0 0 0.1rem rgba(0, 123, 255, 0.25)';
                          }
                        }}
                        onBlur={(e) => {
                          if (!errors.sessionName) {
                            e.target.style.borderColor = '#ced4da';
                            e.target.style.boxShadow = 'inset 0 1px 2px rgba(0, 0, 0, 0.1)';
                          }
                        }}
                      />
                      <FormFeedback>{errors.sessionName}</FormFeedback>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-8">
                      <label className="mb-2 d-flex align-items-center" style={{
                        fontSize: '14px',
                        fontWeight: '600',
                        color: '#495057'
                      }}>
                        <i className="fa fa-clock me-2" style={{color: '#65badbff', fontSize: '12px'}}></i>
                        Time Start
                      </label>

                      <DatePicker
                        id="timeStart"
                        name="timeStart"
                        selected={startDate}
                        onChange={(date) => onChange(date, "startDate")}
                        className={
                          errors.timeStart
                            ? "is-invalid form-control"
                            : "form-control"
                        }
                        showTimeSelect={false}
                        shouldCloseOnSelect={false}
                        dateFormat="yyyy-MM-dd hh:mm aa"
                        placeholderText="Select date and time"
                        invalid={errors.timeStart ? true : false}
                        minDate={getNowOffset(5)}
                        wrapperClassName="date-picker-wrapper"
                      >
                        <div style={{ display: 'flex', justifyContent: 'center', padding: '10px', borderLeft: '1px solid #e9ecef', minWidth: '190px' }}>
                          <AnalogTimePicker
                            selectedDate={startDate}
                            onChange={(newDate) => onChange(newDate, "startDate")}
                            minTime={moment(startDate).isSame(new Date(), 'day') ? getNowOffset(5) : null}
                            disabledIntervals={maintenanceIntervals}
                          />
                        </div>
                      </DatePicker>
                      {/* Custom CSS to style the DatePicker input */}
                      <style jsx='true'>{`
                        .date-picker-wrapper .react-datepicker__input-container input {
                          border-radius: 4px !important;
                          border: ${errors.timeStart ? '2px solid #dc3545' : '1px solid #ced4da'} !important;
                          background-color: #ffffff !important;
                          padding: 8px 12px !important;
                          font-size: 14px !important;
                          font-weight: 400 !important;
                          transition: all 0.2s ease-in-out !important;
                          box-shadow: ${errors.timeStart ? '0 0 0 0.1rem rgba(220, 53, 69, 0.2)' : 'inset 0 1px 2px rgba(0, 0, 0, 0.1)'} !important;
                        }

                        .date-picker-wrapper .react-datepicker__input-container input:focus {
                          border-color: ${errors.timeStart ? '#dc3545' : '#007bff'} !important;
                          box-shadow: ${errors.timeStart ? '0 0 0 0.1rem rgba(220, 53, 69, 0.2)' : 'inset 0 1px 2px rgba(0, 0, 0, 0.1), 0 0 0 0.1rem rgba(0, 123, 255, 0.25)'} !important;
                          outline: none !important;
                        }

                        .date-picker-wrapper .react-datepicker__input-container input:hover:not(:focus) {
                          border-color: ${errors.timeStart ? '#dc3545' : '#adb5bd'} !important;
                        }

                        /* Fix layout for DatePicker with custom child */
                        .react-datepicker {
                          display: flex !important;
                          flex-direction: row !important;
                          width: max-content !important;
                        }
                        .react-datepicker__navigation--next {
                          right: 200px !important;
                          top: 10px !important;
                        }
                        .react-datepicker__navigation--previous {
                          left: 10px !important;
                          top: 10px !important;
                        }
                      `}</style>
                      {errors.timeStart ? (
                        <div className="invalid-error">
                          Time Start is Required.
                        </div>
                      ) : (
                        ""
                      )}

                      {startDate < getNowOffset(15) && (
                        <div className="alert alert-warning mt-2" style={{ fontSize: '13px', lineHeight: '18px' }}>
                          <i className="fa fa-exclamation-triangle" style={{ color: '#DAA520', marginRight: '6px' }}></i>
                          Sessions scheduled less than <strong>15 minutes</strong> in advance may experience setup delays of
                          up to <strong>10 minutes</strong>. Schedule at least <strong>15 minutes</strong> ahead to ensure
                          your session is ready exactly at the requested time.
                        </div>
                      )}
                      {selectionOverlapsMaintenance && (
                        <div className="alert alert-danger mt-2" style={{ fontSize: '13px', lineHeight: '18px' }}>
                          <i className="fa fa-ban" style={{ color: '#dc3545', marginRight: '6px' }}></i>
                          The selected time window overlaps with scheduled maintenance. Please pick another time.
                        </div>
                      )}
                    </div>

                    <div className="col-md-4">
                      <label className="mb-2 d-flex align-items-center" style={{
                        fontSize: '14px',
                        fontWeight: '600',
                        color: '#495057'
                      }}>
                        <i className="fa fa-hourglass-half me-2" style={{color: '#65badbff', fontSize: '12px'}}></i>
                        Duration
                      </label>
                      <select
                        className={
                          errors.duration
                            ? "is-invalid form-control mb-2"
                            : "form-control mb-2"
                        }
                        name="duration"
                        value={duration}
                        onChange={(e) => onChangeValue(e)}
                        style={{
                          borderRadius: '4px',
                          border: errors.duration ? '2px solid #dc3545' : '1px solid #ced4da',
                          backgroundColor: '#ffffff',
                          padding: '8px 12px',
                          fontSize: '14px',
                          fontWeight: '400',
                          transition: 'all 0.2s ease-in-out',
                          boxShadow: errors.duration ? '0 0 0 0.1rem rgba(220, 53, 69, 0.2)' : 'inset 0 1px 2px rgba(0, 0, 0, 0.1)'
                        }}
                        onFocus={(e) => {
                          if (!errors.duration) {
                            e.target.style.borderColor = '#007bff';
                            e.target.style.boxShadow = 'inset 0 1px 2px rgba(0, 0, 0, 0.1), 0 0 0 0.1rem rgba(0, 123, 255, 0.25)';
                          }
                        }}
                        onBlur={(e) => {
                          if (!errors.duration) {
                            e.target.style.borderColor = '#ced4da';
                            e.target.style.boxShadow = 'inset 0 1px 2px rgba(0, 0, 0, 0.1)';
                          }
                        }}
                      >
                        <option value="">Select duration</option>
                        <option value="30 minutes">30 minutes</option>
                        <option value="60 minutes">1 hour</option>
                        <option value="90 minutes">1.5 hours</option>
                        <option value="120 minutes">2 hours</option>
                        <option value="150 minutes">2.5 hours</option>
                        <option value="180 minutes">3 hours</option>
                        <option value="210 minutes">3.5 hours</option>
                        <option value="240 minutes">4 hours</option>
                      </select>
                      {errors.duration ? (
                        <div className="invalid-error">{errors.duration}</div>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-12">
                      <label className="mb-2 d-flex align-items-center" style={{
                        fontSize: '14px',
                        fontWeight: '600',
                        color: '#495057'
                      }}>
                        <i className="fa fa-globe me-2" style={{color: '#65badbff', fontSize: '12px'}}></i>
                        Timezone
                      </label>
                      <Input
                        type="text"
                        className="form-control mb-2"
                        placeholder="Timezone"
                        id="timezone"
                        name="timezone"
                        value={new Date().toTimeString().slice(9)}
                        readOnly={true}
                        style={{
                          borderRadius: '4px',
                          border: '1px solid #ced4da',
                          backgroundColor: '#f8f9fa',
                          padding: '8px 12px',
                          fontSize: '14px',
                          fontWeight: '400',
                          transition: 'all 0.2s ease-in-out',
                          boxShadow: 'inset 0 1px 2px rgba(0, 0, 0, 0.1)',
                          color: '#6c757d'
                        }}
                      />
                    </div>
                  </div>

                  {/* AI Voice Features Badge Section */}
                  <div className="row">
                    <div className="col-md-12">
                      <label className="mb-2 d-flex align-items-center" style={{
                        fontSize: '14px',
                        fontWeight: '600',
                        color: '#495057'
                      }}>
                        <i className="fa fa-star me-2" style={{color: '#65badbff', fontSize: '12px'}}></i>
                        Features
                      </label>
                      <div className="features-badges p-3" style={{
                        display: 'flex',
                        gap: '8px',
                        flexWrap: 'wrap',
                        background: 'linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%)',
                        borderRadius: '8px',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                        border: '1px solid rgba(255,255,255,0.3)'
                      }}>
                        {/* Video Animation badge - always shown */}
                        <span className="badge" style={{
                          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                          color: 'white',
                          padding: '8px 12px',
                          borderRadius: '20px',
                          fontSize: '12px',
                          fontWeight: '600',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '6px',
                          boxShadow: '0 3px 12px rgba(102, 126, 234, 0.3)'
                        }}>
                          <i className="fa fa-video"></i>
                          Video Animation
                        </span>

                        {/* AI Voice badge - only shown when voice morphing is enabled */}
                        {((props.formType === "virtualizationForm" && props.animationData?.enable_morphing) ||
                          (props.formType === "sessionsForm" && props.options?.find(opt => opt.id === template_id)?.enable_morphing)) && (
                          <span className="badge premium-ai-badge" style={{
                            background: 'linear-gradient(135deg, #ffecd2 0%, #fcb69f 100%)',
                            color: '#8B4513',
                            padding: '8px 12px',
                            borderRadius: '20px',
                            fontSize: '12px',
                            fontWeight: '700',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '6px',
                            boxShadow: '0 3px 12px rgba(252, 182, 159, 0.4), 0 0 0 1px rgba(252, 182, 159, 0.2)',
                            border: '1px solid rgba(218, 165, 32, 0.3)',
                            textShadow: '0 1px 2px rgba(0,0,0,0.1)'
                          }}>
                            <i className="fa fa-microphone"></i>
                            AI Voice
                            <i className="fa fa-crown" style={{ color: '#DAA520' }}></i>
                          </span>
                        )}
                      </div>
                      {isVoiceMorphingEnabled() && (
                        <div className="mt-2">
                          <small className="text-muted" style={{ fontSize: '11px', fontStyle: 'italic' }}>
                            <i className="fa fa-info-circle" style={{ color: '#DAA520', marginRight: '4px' }}></i>
                            Sessions with AI Voice feature cost 2x the regular price
                          </small>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12">
                      {
                        reservation_id ? (
                          utctimeStart < minUpdateEventDate ? (
                            <div className="alert alert-warning  mt-2">
                              Canceling or reschedule is only possible more than 24 hours before the scheduled DeepTherapy session.
                            </div>

                          ) : ""
                        ) : ""

                      }
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12">
                      {
                        cost > auth.total_coin ? (
                          <div className="alert alert-warning mt-2">
                            Your balance is not enough to update this session.
                            <Link to={'/subscription'} style={{ color: "#00a0fe" }}>
                              <strong>Get more credits</strong>
                            </Link>
                          </div>

                        ) : ""
                      }
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12">
                      {
                        errormessage != '' ? (
                          <div className="alert alert-danger alert-dismissible mt-2">
                            <span className="close" onClick={() => setErrormessage("")}>&times;</span>
                            {errormessage}
                          </div>

                        ) : ""
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer className="" style={{ display: 'inline' }}>
          <div className="row">
            <div className="col-md-6">
              {
                reservation_id ? (

                  <Button
                    variant="contained"
                    className="btn-warning text-white"
                    onClick={() => delete_reservations(reservation_id)}
                  >
                    Cancel Session
                  </Button>

                ) : ""
              }
            </div>
            {
              reservation_id ? render_footer_for_update_schedule() : render_footer_for_create_new_schedule()
            }
          </div>
        </Modal.Footer>
      </Modal>

      {/* CSS for enhanced badge styling */}
      <style jsx='true'>{`
        @keyframes premium-glow {
          0%, 100% {
            box-shadow: 0 3px 12px rgba(252, 182, 159, 0.4), 0 0 0 1px rgba(252, 182, 159, 0.2);
          }
          50% {
            box-shadow: 0 4px 16px rgba(252, 182, 159, 0.6), 0 0 0 1px rgba(252, 182, 159, 0.4), 0 0 20px rgba(218, 165, 32, 0.3);
          }
        }

        @keyframes crown-sparkle {
          0%, 100% {
            transform: scale(1) rotate(0deg);
            opacity: 0.8;
          }
          50% {
            transform: scale(1.1) rotate(5deg);
            opacity: 1;
          }
        }

        .premium-ai-badge {
          animation: premium-glow 3s ease-in-out infinite;
          transition: all 0.3s ease;
        }

        .premium-ai-badge:hover {
          transform: translateY(-1px);
          box-shadow: 0 5px 20px rgba(252, 182, 159, 0.7), 0 0 0 2px rgba(252, 182, 159, 0.4), 0 0 30px rgba(218, 165, 32, 0.4) !important;
          animation: none;
        }

        .premium-ai-badge .fa-crown {
          animation: crown-sparkle 2s ease-in-out infinite;
        }

        /* Badge hover effects */
        .features-badges .badge {
          transition: all 0.3s ease;
        }

        .features-badges .badge:not(.premium-ai-badge):hover {
          transform: translateY(-1px);
          box-shadow: 0 4px 12px rgba(102, 126, 234, 0.5) !important;
        }
      `}</style>
    </>
  );
}
